/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Unauthenticated client for the public Service Request share link — no Authorization
// header is ever attached, matching the intentionally logged-out nature of this route.
const publicServiceRequestClient = axios.create({
  baseURL: `${API_URL}/api/public/service-requests`,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default publicServiceRequestClient;
